// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3UuJs","left":"InfoRow_left__3zqsl"};